define(function (require) {
    "use strict";
    var Backbone = require('backbone');

    return Backbone.View.extend({
        registerListener: function (eventName, listener) {
            var eventObj = {};
            eventObj[eventName] = listener;
            this.listenTo(Backbone, eventObj);
        },
        registerListenerOnce: function (eventName, listener) {
            Backbone.once(eventName, listener);
        },
        triggerEvent: function (eventName, params) {
            Backbone.trigger.apply(Backbone, [eventName].concat(params));
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/common/views/BackboneView.js
// module id = 1110
// module chunks = 27 28 29